import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as Mui from "@mui/material";
import { Box, Typography } from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote"; // Planned
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Present
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // Overtime
import PersonOffIcon from "@mui/icons-material/PersonOff"; // Missing
import WarningIcon from "@mui/icons-material/Warning"; // Absent
import ScheduleIcon from "@mui/icons-material/Schedule";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { themes } from "services/constants";
import { setCurrentScreen } from "services/Redux/userManagament";
import { setGlobalSearchValue } from "services/Redux/userToken";
import {
  setDepartmentId,
  setDepartmentLeadId,
  setDepartmentName,
} from "services/Redux/userManagament";

export const CardView = ({
  departmentList,
  setSelectedComponent,
  setDepartmentIdValue,
  setDepartmentNameValue,
  setDepartmentApi,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const DepartmentCard = ({
    dept,
    setSelectedComponent,
    setDepartmentIdValue,
    setDepartmentNameValue,
  }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event, dept) => {
      setAnchorEl(event.currentTarget);
      dispatch(setDepartmentId(dept.id));
      dispatch(setDepartmentLeadId(dept.department_lead_id));
      dispatch(setDepartmentName(dept.name));
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    return (
      <Box
        onClick={() => {
          setDepartmentIdValue(dept?.id);
          setDepartmentNameValue(dept?.name);
          setDepartmentApi(true);
          setSelectedComponent("Employee View");
        }}
        sx={{
          width: "100%",
          maxWidth: 270,
          minHeight: 270,
          border: "1px solid #ddd",
          borderRadius: 2,
          overflow: "hidden",
          background: "#f9f9f9",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#f5f5fd",
            borderBottom: `2px solid ${themes.sidebarDivider}`,
          }}
        >
          <Typography fontWeight={600} sx={{ mt: 1, ml: 1 }}>
            {dept.name}
          </Typography>
          <Mui.IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleMenuOpen(e, dept);
            }}
          >
            <MoreVertIcon />
          </Mui.IconButton>
          <Mui.Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Mui.MenuItem
              onClick={() => {
                dispatch(setGlobalSearchValue(""));
                history.push("/admin/attendance/view/members");
                handleMenuClose();
              }}
            >
              View Members
            </Mui.MenuItem>

            <Mui.MenuItem
              onClick={() => {
                dispatch(setCurrentScreen("Shift"));
                localStorage.setItem("currentSubMenu", "Shift");
                dispatch(setGlobalSearchValue(""));
                history.push("/admin/teamzone/plan-shift");
                handleMenuClose();
              }}
            >
              Plan Shift
            </Mui.MenuItem>
          </Mui.Menu>
        </Box>
        <Typography sx={{ mb: 1, ml: 1 }}>
          Total no of staffs <b> :</b> <b>{dept.total}</b>
        </Typography>
        <Box sx={{ paddingLeft: 0.8, paddingRight: 0.8 }}>
          {/* Stats */}
          {dept.stats.map((item, i) => (
            <Box
              key={i}
              sx={{
                padding: 0.2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                py: 0.4,
              }}
            >
              <Typography
                variant="body2"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <item.icon sx={{ color: item.color, fontSize: 18 }} />
                {item.label}
              </Typography>

              <Typography variant="body2">{item.value}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  const departments = departmentList.map((dept) => ({
    name: dept.department_name,
    total: dept.total_staff_count,
    id: dept.department_id,
    department_lead_id: dept.department_lead_id,
    stats: [
      {
        label: "Planned",
        value: dept.staff_planned_count,
        color: "#ff00cc",
        icon: EventNoteIcon,
      },
      {
        label: "Present",
        value: dept.staff_present_count,
        color: "#4caf50",
        icon: CheckCircleIcon,
      },
      {
        label: "Overtime",
        value: dept.staff_overtime_count,
        color: "#009688",
        icon: AccessTimeIcon,
      },
      {
        label: "Missing",
        value: dept.staff_missing_count,
        color: "#ff9800",
        icon: PersonOffIcon,
      },
      {
        label: "Absent",
        value: dept.staff_absent_count,
        color: "#f44336",
        icon: WarningIcon,
      },
      {
        label: "Late / Early",
        value: dept.staff_late_early,
        color: "#3f51b5",
        icon: ScheduleIcon,
      },
    ],
  }));

  return (
    <React.Fragment>
      <Box sx={{ paddingLeft: 1, paddingRight: 1 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "minmax(0, 1fr)",
              sm: "repeat(auto-fit, minmax(250px, 270px))",
            },
            justifyContent: "center",
            gap: { xs: 2, sm: 4, md: 8 },
            mt: 2,
            minWidth: 0,
          }}
        >
          {departments.map((dept, index) => (
            <DepartmentCard
              key={index}
              dept={dept}
              setSelectedComponent={setSelectedComponent}
              setDepartmentIdValue={setDepartmentIdValue}
              setDepartmentNameValue={setDepartmentNameValue}
            />
          ))}
        </Box>
      </Box>
    </React.Fragment>
  );
};
